import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loader from 'components/shared/Loader';
import { getText, trackGA } from 'misc/helpers';
import * as types from 'misc/types';

class Company extends Component {
    render = () => {
        const { company } = this.props;

        return (
            <Loader objectToLoad={company}>
                {company.isLoaded && (
                    <div className="settings-view">
                        <h1>{getText('_3_2_TitelCompany', 'Företag')}</h1>
                        <p>{getText('_11_0_text_company', 'Här kan du se en lista på de företag du kan få post ifrån.')}</p>
                        <div className="settings-grid">
                            {company.data.map(companyInfo => (
                                <div className="grid-item" style={{ width: '100%' }} key={companyInfo.key}>
                                    {companyInfo.sender.name}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </Loader>
        );
    };

    componentDidMount() {
        // Get company list
        const { dispatch } = this.props;
        dispatch({ type: types.SAGA_COMPANY_GET.REQUEST });

        trackGA('11.0 Företag avsändare');
    }
}

// Check if customer has pending email or mobile phone
// and set the appropriate values to the input fields
const mapStateToProps = (state, ownProps) => {
    return {
        company: state.company,
        sessions: state.sessions
    };
};

export default connect(mapStateToProps)(Company);



// WEBPACK FOOTER //
// ./src/components/views/settings/Company.js